import { useAtom } from 'jotai';

import { useAtomCallbackMemoized } from '../hooks/useAtomCallbackMemoized';
import { useOnInactiveMobileScreenDetected } from '../hooks/useOnInactiveMobileScreenDetected';
import { LocalMediaStatus, localVideoContextAtom, useStartVideo, useStopVideo } from '../video-sdk';
import { videoWasOnAtScreenLeaveAtom } from '../video-sdk/twilio';

export function useResetVideoOnMobileNavigation() {
  const [_, setVideoWasOnAtScreenLeave] = useAtom(videoWasOnAtScreenLeaveAtom);
  const getVideoWasOnAtScreenLeave = useAtomCallbackMemoized((get) => {
    return get(videoWasOnAtScreenLeaveAtom);
  }, []);
  const getLocalVideoTrack = useAtomCallbackMemoized((get) => {
    return get(localVideoContextAtom);
  }, []);

  const stopVideo = useStopVideo();
  const startVideo = useStartVideo();

  const screenLeaveCallback = () => {
    const videoIsOn = getLocalVideoTrack()?.status === LocalMediaStatus.READY;
    setVideoWasOnAtScreenLeave(videoIsOn);
    if (videoIsOn) {
      stopVideo();
    }
  };
  const screenReturnCallback = () => {
    if (getVideoWasOnAtScreenLeave()) {
      startVideo();
    }
    setVideoWasOnAtScreenLeave(null);
  };

  useOnInactiveMobileScreenDetected(screenLeaveCallback, screenReturnCallback);
}
